import React, { useState } from 'react';
import { AlertTriangle, Mail, Loader2 } from 'lucide-react';
import { resendVerificationEmail } from '../../lib/auth';

interface EmailVerificationBannerProps {
  user: any;
}

export function EmailVerificationBanner({ user }: EmailVerificationBannerProps) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  if (user.emailVerified) return null;

  const handleResendEmail = async () => {
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await resendVerificationEmail();
      setSuccess('Verification email sent! Please check your inbox.');
    } catch (err: any) {
      setError(err.message || 'Failed to send verification email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white/20 border-l-4 border-amber-400 p-20 pb-4 mt-8">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-5 w-5 text-amber-400" />
        </div>
        <div className="ml-3 flex-1">
          <div className="text-sm text-white/80">
            <p className="font-medium">Please verify your email address</p>
            <p className="mt-1">
              A verification email has been sent to {user.email}. Please check your inbox and click the verification link.
            </p>
            {error && (
              <p className="mt-2 text-white/80">{error}</p>
            )}
            {success && (
              <p className="mt-2 text-green-600">{success}</p>
            )}
          </div>
          <div className="mt-4">
            <button
              onClick={handleResendEmail}
              disabled={loading}
              className="flex items-center gap-2 text-sm font-medium text-white/70 hover:text-amber-400 disabled:opacity-50"
            >
              {loading ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  Sending...
                </>
              ) : (
                <>
                  <Mail className="h-4 w-4" />
                  Resend verification email
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}